<template>
  <div class="container">
    <div class="icon">
      <svg
        width="48"
        height="48"
        viewBox="0 0 48 48"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M45.3582 3.04084C45.0032 2.95642 44.6297 3.00199 44.3054 3.16928L42.0001 4.32053L39.6751 3.15803C39.4669 3.0539 39.2372 2.99969 39.0043 2.99969C38.7715 2.99969 38.5418 3.0539 38.3336 3.15803L35.9795 4.32147L33.6564 3.15803C33.4475 3.05314 33.217 2.99851 32.9832 2.99851C32.7495 2.99851 32.519 3.05314 32.3101 3.15803L30.0001 4.31772L27.7079 3.16084C27.4996 3.05523 27.2695 2.99972 27.0359 2.99875C26.8024 2.99777 26.5718 3.05135 26.3626 3.15522L24.0001 4.3224L21.6751 3.15709C21.4665 3.05301 21.2365 2.99884 21.0034 2.99884C20.7703 2.99884 20.5403 3.05301 20.3317 3.15709L18.0001 4.32053L15.6714 3.15709C15.3712 3.0066 15.0291 2.96121 14.7001 3.02818C14.371 3.09515 14.0739 3.27061 13.8564 3.52647C13.6219 3.8059 13.4955 4.16017 13.5001 4.5249V26.9987L13.5048 27.0033H31.5001C32.2958 27.0033 33.0588 27.3194 33.6214 27.882C34.184 28.4446 34.5001 29.2077 34.5001 30.0033V39.7487C34.5001 42.6483 37.6004 44.9987 40.5001 44.9987H41.6251C42.9181 44.9987 44.158 44.485 45.0723 43.5708C45.9865 42.6566 46.5001 41.4166 46.5001 40.1237V4.49865C46.5004 4.16292 46.388 3.83681 46.181 3.57251C45.974 3.30821 45.6843 3.121 45.3582 3.04084ZM39.0001 22.4987H27.047C26.237 22.4987 25.5376 21.8762 25.502 21.0662C25.4929 20.8637 25.5249 20.6615 25.596 20.4718C25.6672 20.2821 25.7761 20.1088 25.9161 19.9623C26.0561 19.8158 26.2243 19.6992 26.4106 19.6195C26.597 19.5398 26.7975 19.4987 27.0001 19.4987H38.9532C39.7632 19.4987 40.4626 20.1212 40.4982 20.9312C40.5074 21.1336 40.4754 21.3358 40.4042 21.5255C40.333 21.7152 40.2242 21.8886 40.0842 22.035C39.9441 22.1815 39.7759 22.2981 39.5896 22.3778C39.4033 22.4575 39.2028 22.4986 39.0001 22.4987ZM39.0001 14.9987H21.047C20.237 14.9987 19.5376 14.3762 19.502 13.5662C19.4929 13.3637 19.5249 13.1615 19.596 12.9718C19.6672 12.7821 19.7761 12.6088 19.9161 12.4623C20.0561 12.3158 20.2243 12.1992 20.4106 12.1195C20.597 12.0398 20.7975 11.9987 21.0001 11.9987H38.9532C39.7632 11.9987 40.4626 12.6212 40.4982 13.4312C40.5074 13.6336 40.4754 13.8358 40.4042 14.0255C40.333 14.2152 40.2242 14.3886 40.0842 14.535C39.9441 14.6815 39.7759 14.7981 39.5896 14.8778C39.4033 14.9575 39.2028 14.9986 39.0001 14.9987Z"
          fill="#7B6CCC"
        />
        <path
          d="M31.5 39.75V31.5C31.5 31.1022 31.342 30.7206 31.0607 30.4393C30.7794 30.158 30.3978 30 30 30H4.5C3.7043 30.0025 2.94197 30.32 2.37976 30.8831C1.81755 31.4462 1.50124 32.209 1.5 33.0047C1.5 37.7437 2.04187 39.7144 2.85562 41.2144C4.23656 43.7616 6.73688 45 10.5 45H33.5325C33.6065 45.0001 33.6788 44.9782 33.7404 44.9373C33.8021 44.8963 33.8502 44.838 33.8787 44.7698C33.9073 44.7015 33.915 44.6263 33.901 44.5537C33.8869 44.4811 33.8517 44.4142 33.7997 44.3616C32.9128 43.4719 31.5 42.2812 31.5 39.75Z"
          fill="#7B6CCC"
        />
      </svg>
    </div>
    <div
      variant="page-title"
      style="margin-bottom: 16px; max-width: 600px; text-align: center"
    >
      Még nem készült elszámolási riportod!
    </div>
    <div variant="table-head-button-label">
      Ennek oka lehet, hogy még nem hoztál létre eseményt és/vagy nem zárult le
      egy teljes számlázási hónap.
    </div>
  </div>
</template>

<script>
export default {
  props: ["handleClick"],
};
</script>

<style scoped>
.container {
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
}
.icon {
  color: var(--color-blue-04);
  display: flex;
  justify-content: center;
  align-items: center;
  width: 120px;
  height: 120px;
  background-color: var(--color-red-07);
  border-radius: 60px;
  margin-bottom: 32px;
  font-size: 48px;
}
</style>